import { createWsConnectionSlice } from '@skynet/data-ws-core';
import { esActions } from './actions';

const wsEsSlice = createWsConnectionSlice('wsEs', esActions);

export type WsEsState = ReturnType<typeof wsEsSlice.getInitialState>;

export const wsEsActions = wsEsSlice.actions;

export default wsEsSlice.reducer;
